module.exports = __webpack_public_path__ + "ga.svg?da92141c2a39f8adcfeea712c0a77dee";